import { useQuery } from '@tanstack/vue-query';

import { fetchFreedomFriendsSelfInfo } from '../api';

/**
 * Plain vue-query composable. vue-query already dedupes by `queryKey`, so
 * the previous Pinia setup-store wrapper bought us nothing functional and
 * forced an FSD violation — `entities/products/lib.ts` had to call the
 * store from a non-setup context, which a plain `useQuery` can't support.
 * `staleTime: Infinity` preserves the prior "fetch once per session"
 * behaviour the singleton observer provided.
 *
 * Returns vue-query refs as-is. Consumers must use `.value` when reading
 * `data` / `isLoading` / `isError` in script blocks (templates may rely on
 * Vue's top-level ref auto-unwrap when destructured). `suspense` is a
 * method.
 */
export const useFreedomFriendsSelfInfo = () =>
  useQuery({
    queryKey: ['freedom-friends-self-info'],
    queryFn: fetchFreedomFriendsSelfInfo,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
